export const dayChange = ( value ) => {
    return {
        type: 'CHANGE_DAY',
        data: value
    }
}

export const toggleSwitch = ( show, state=null ) => {
    return {
        type: show,
        data: state
    }
}

export const setActiveTab = ( tabIndex ) => {
    return {
        type: 'SET_ACTIVE_TAB',
        data: tabIndex,
    }
}

export const popupChange = ( show ) => {
    return {
        type: 'CHANGE_POPUP',
        data: show
    }
}

export const setProjectData = ( data ) => {
    return {
        type: 'SET_DATA',
        data: data
    }
}

export const setCardsGroupsWithHistoricalObservations = ( data ) => {
    return {
        type: 'SET_CARDS_GROUPS_WITH_HISTORICAL_OBSERVATIONS',
        data: data
    }
}

export const addCardsGroups = ( data ) => {
    return {
        type: 'ADD_CARDSGROUPS',
        data: data
    }
}

export const addCards = ( data ) => {
    return {
        type: 'ADD_CARDS',
        data: data
    }
}

export const addAreas = ( data ) => {
    return {
        type: 'ADD_AREAS',
        data: data
    }
}

export const entryChange = ( value ) => {
    return {
        type: 'CHANGE_ENTRY',
        data: value
    }
}

export const setItemsData = ( data ) => {
    return {
        type: 'SET_ITEMS_DATA',
        data: data
    }
}

export const setItemProgress = ( data ) => {
    return {
        type: 'SET_ITEM_PROGRESS',
        data: data
    }
}

export const selectItemChange = ( data ) => {
    return {
        type: 'SELECT_ITEM',
        data: data
    }
}

export const setProjectUsers = ( data ) => {
    return {
        type: 'SET_USERS',
        data: data
    }
}

export const selectedCardsGroupsChange = ( data ) => {
    return {
        type: 'CHANGE_SELECTED_CARDSGROUPS',
        data: data
    }
}

export const loadedLevelsChange = ( data ) => {
    return {
        type: 'ADD_LEVELS',
        data: data
    }
}

export const responseDataChange = ( data ) => {
    return {
        type: 'SET_RESPONSE_DATA',
        data: data
    }
}

export const setLoadedLevels = ( data ) => {
    return {
        type: 'SET_LEVELS',
        data: data
    }
}

export const editCards = ( data ) => {
    return {
        type: 'EDIT_CARDS',
        data: data
    }
}

export const deleteCards = ( data ) => {
    return {
        type: 'DELETE_CARDS',
        data: data
    }
}

export const deleteCardsFromCardsGroups = ( data ) => {
    return {
        type: 'DELETE_CARDS_FROM_CARDSGROUPS',
        data: data
    }
}

export const setQualityProgress = ( data ) => {
    return {
        type: 'SET_QUALITY_PROGRESS',
        data: data
    }
}

export const popUpMessageChange = ( data ) => {
    return {
        type: 'SET_POPUP_MESSAGE',
        data: data
    }
}

export const closedCardsGroupsChange = ( data ) => {
    return {
        type: 'CLOSED_CARDSGROUPS',
        data: data
    }
}

export const standByCardsGroupsChange = ( data ) => {
    return {
        type: 'STAND_BY_CARDSGROUPS',
        data: data
    }
}

export const popUpMenuChange = ( data ) => {
    return {
        type: 'SET_POPUP_MENU',
        data: data
    }
}

export const deletedCardsGroupsChange = ( data ) => {
    return {
        type: 'DELETED_CARDSGROUPS',
        data: data
    }
}

export const setUserRole = ( data ) => {
    return {
        type: 'SET_USER_ROLE',
        data: data
    }
}

export const setUserData = ( data ) => {
    return {
        type: 'SET_USER_DATA',
        data: data
    }
}

export const setCustomcardTypes = ( data ) => {
    return {
        type: 'SET_CUSTOMCARD_TYPES',
        data: data
    }
}

export const setAddProgress = ( data ) => {
    return {
        type: 'SET_ADD_PROGRESS',
        data: data
    }
}

export const setAddPayment = ( data ) => {
    return {
        type: 'SET_ADD_PAYMENT',
        data: data
    }
}

export const addFeaturesGroups = ( data ) => {
    return {
        type: 'ADD_FEATURES_GROUPS',
        data: data
    }
}

export const editFeaturesGroup = ( data, levelId ) => {
    return {
        type: 'EDIT_FEATURES_GROUP',
        data: data,
        levelId: levelId
    }
}

export const setCycleData = ( data ) => {
    return {
        type: 'SET_CYCLE_DATA',
        data: data
    }
}

export const loadingLevelIdChange = ( data ) => {
    return {
        type: 'LOADING_LEVEL_ID',
        data: data
    }
}

export const addMatches = ( matches ) => {
    return {
        type: 'ADD_MATCHES',
        data: matches
    }
}

export const editFigures = ( figuresData, figuregroupsMap ) => {
    return {
        type: 'EDIT_FIGURES',
        figuresData: figuresData,
        figuregroupsMap: figuregroupsMap
    }
}

export const signaturesUserChange = ( userId ) => {
    return {
        type: 'CHANGE_SIGNATURES_USER',
        data: userId
    }
}

export const visibleCardsGroupsChange = ( cardsGroupIds ) => {
    return {
        type: 'CHANGE_VISIBLE_CARDS_GROUP_IDS',
        data: cardsGroupIds
    }
}

export const visibleWhatsAppObservationsChange = ( observationIds ) => {
    return {
        type: 'CHANGE_VISIBLE_WHATSAPP_OBSERVATIONS_IDS',
        data: observationIds
    }
}

export const addFirstCardDescription = ( data ) => {
    return {
        type: 'ADD_FIRST_CARD_DESCRIPTION',
        data: data
    }
}

export const setPaint = ( data ) => {
    return {
        type: 'SET_PAINT',
        data: data
    }
}

export const filterChange = ( type, data ) => {
    return {
        type: type,
        data: data
    }
}

export const opacityChange = ( value ) => {
    return {
        type: 'CHANGE_OPACITY',
        data: value
    }
}

export const signaturesFilterHistoricChange = ( value ) => {
    return {
        type: 'SIGNATURES_FILTER_HISTORIC',
        data: value
    }
}

export const signaturesFilterChange = ( value ) => {
    return {
        type: 'SIGNATURES_FILTER_REDUCER',
        data: value
    }
}

export const setBreakCoordinatesModal = ( value ) => {
    return {
        type: 'SET_BREAK_COORDINATES_MODAL',
        data: value,
    }
}

export const setWhatsAppObservationsMode = ( enabled ) => {
    return {
        type: 'SET_WHATSAPP_OBSERVATIONS_MODE',
        data: enabled
    }
}

export const setWhatsAppObservations = ( data ) => {
    return {
        type: 'SET_WHATSAPP_OBSERVATIONS',
        data: data
    }
}

export const setSelectedWhatsAppObservations = ( observationIds ) => {
    return {
        type: 'SET_SELECTED_WHATSAPP_OBSERVATIONS',
        data: observationIds
    }
}

export const setWhatsAppObservationsPopup = ( data ) => {
    return {
        type: 'SET_WHATSAPP_OBSERVATIONS_POPUP',
        data: data
    }
}

export const setWhatsAppObservationsFilters = ( data ) => {
    return {
        type: 'SET_WHATSAPP_OBSERVATIONS_FILTERS',
        data: data
    }
}

export const toggleWhatsAppFilters = () => {
    return {
        type: 'TOGGLE_WHATSAPP_FILTERS'
    }
}

export const selectedTeamIdsChange = ( data ) => {
    return {
        type: 'SELECTED_TEAM_IDS',
        data: data
    }
}